export default __webpack_public_path__ + "static/media/Group 5850@2x.ea2e6bc4.jpg";